export default class Martyr
{
    constructor(instructions, specifications, employee_info, family_info){
        this.instructions       = instructions
        this.specifications     = specifications
        this.employee_info      = employee_info
        this.family_info        = family_info
    }

    toFormData(){
        let fData = new FormData()
        
        //مواصفات الوحدة السكنية 
        fData.append('housing_city_id', this.specifications.city_id);
        fData.append('housing_housing_unit_id', this.specifications.name_residential_unit_id);
        fData.append('housing_housing_unit_type_id', this.specifications.type_residential_unit_id);
        // fData.append('housing_housing_build_style_id', this.specifications.style_residential_unit_id);
        fData.append('housing_housing_unit_area_id', this.specifications.area_residential_unit_id);
  
        // معلومات المنتسب 
        fData.append('employee_name1', this.employee_info.name1);        
        fData.append('employee_name2', this.employee_info.name2); 
        fData.append('employee_name3', this.employee_info.name3);                   
        fData.append('employee_name4', this.employee_info.name4);
        fData.append('employee_family_name', this.employee_info.family_name);        
        fData.append('employee_mother_name', this.employee_info.mother_name); 
        fData.append('employee_birth_date', this.employee_info.birth_date);                   
        fData.append('employee_gender_id', this.employee_info.gender_id);
        fData.append('employee_phone', this.employee_info.phone1);        
        fData.append('employee_marital_status_id', this.employee_info.marital_status_id); 
        fData.append('employee_certificate_id', this.employee_info.certificate_id);                   
        fData.append('employee_specialization', this.employee_info.academic_specialization);
        fData.append('employee_dept', this.employee_info.dept);
        fData.append('employee_date_hire', this.employee_info.employment_date);
        fData.append('employee_job_title_id', this.employee_info.Job_title_id);
        
        if(this.employee_info.id_type == '1'){
            fData.append('employee_nationality_number', this.employee_info.nationality_number);
        }else{
            fData.append('employee_national_id_number', this.employee_info.national_id_number);
            fData.append('employee_national_id_number_record', this.employee_info.national_id_number_record);
            fData.append('employee_national_id_number_paper', this.employee_info.national_id_number_paper);
        }

        fData.append('employee_address_city_id', this.employee_info.city_id);        
        fData.append('employee_address_district', this.employee_info.district); 
        fData.append('employee_address_region', this.employee_info.region);                   
        fData.append('employee_address_mahla', this.employee_info.mahla);
        fData.append('employee_address_zqaq', this.employee_info.zqaq);        
        fData.append('employee_address_dar', this.employee_info.dar);

        fData.append('employee_housing_info_real_estate_id', this.employee_info.own_property_id);
        fData.append('employee_housing_info_accommodation_id', this.employee_info.house_type_id);                   
        fData.append('employee_housing_info_build_material_type_id', this.employee_info.construction_type_id);
        fData.append('employee_housing_info_address_privacy_id', this.employee_info.housing_privacy_id);        
        fData.append('employee_housing_info_building_condition_id', this.employee_info.construction_condition_id); 
        fData.append('employee_housing_info_area', this.employee_info.housing_area);

        for (let i = 0; i < this.employee_info.health_status_id.length; i++) {
            const element = this.employee_info.health_status_id[i];
            fData.append('employee_health_statuses['+i+']', element.id);            
        }
        fData.append('employee_have_martyr', this.employee_info.families_martyrs_id);
        if (this.employee_info.families_martyrs_id == 1 || this.employee_info.families_martyrs_id == 2) {
            fData.append('employee_martyr_category_id', this.employee_info.martyr_class_id);
            fData.append('employee_martyr_attachment', this.employee_info.attachment_families_martyrs);    
        }

        fData.append('employee_basic_attachment', this.employee_info.attachment_basic);    
        if (this.employee_info.health_status_id.findIndex((o) => o.id == 1) == -1 && typeof this.employee_info.attachment_health == 'object') {
            fData.append('employee_health_attachment', this.employee_info.attachment_health);
        }    

        // معلومات عائلة مقدم الطلب 
        for (let i = 0; i < this.family_info.fields.length; i++) {
            const element = this.family_info.fields[i];
            
            fData.append('employee_family['+i+'][name1]', element.name1); 
            fData.append('employee_family['+i+'][name2]', element.name2); 
            fData.append('employee_family['+i+'][name3]', element.name3); 
            fData.append('employee_family['+i+'][name4]', element.name4); 
    
            fData.append('employee_family['+i+'][family_name]', element.family_name); 
            fData.append('employee_family['+i+'][mother_name]', element.mother_name); 
            fData.append('employee_family['+i+'][birth_date]', element.birth_date); 
            fData.append('employee_family['+i+'][gender_id]', element.gender_id); 
            fData.append('employee_family['+i+'][marital_status_id]', element.marital_status_id); 
            fData.append('employee_family['+i+'][certificate_id]', element.certificate_id); 
            fData.append('employee_family['+i+'][real_estate_id]', element.own_property_id);
    
            for (let j = 0; j < element.health_status_id.length; j++) {
                const el = element.health_status_id[j];
                fData.append('employee_family['+i+'][health_statuses]['+j+']', el.id);            
            }

            fData.append('employee_family['+i+'][relation_relative_id]', element.relative_relation_id); 
            fData.append('employee_family['+i+'][job_id]', element.job_id); 

            if (element.job_id == 3) {
                fData.append('employee_family['+i+'][job_title]', element.Workplace);
            }

            fData.append('employee_family['+i+'][basic_attachment]', element.attachment_family_basic);

            if (element.health_status_id.findIndex((o) => o.id == 1) == -1 && typeof element.attachment_family_health == 'object') {
                fData.append('employee_family['+i+'][health_attachment]', element.attachment_family_health);
            }
        }

        return fData
    }
}

